import React, { useEffect, useState } from "react";
import AifaLogo from "../../financial management/billings/Invoice/AIFA-Logo-2.png";
import { useGetSingleQoutaionQuery } from "../../../../features/quotaion/quotaionApiSlice";
import { useParams } from "react-router-dom";
import BG from "../../../../images/aifaBGimage.png";
import { PDFDownloadLink } from "@react-pdf/renderer";
import QuotationPDF from "./QuotationPDF";
import { bankDetails } from "./bank_details";

const QuotationView = () => {
  const [isPDFDownloadCreating, setIsPDFDownloadCreating] = useState(false);
  const { quotationId } = useParams();
  const { data: getSingleQoutaion, refetch } =
    useGetSingleQoutaionQuery(quotationId);

  useEffect(() => {
    refetch();
  }, [getSingleQoutaion, refetch]);

  function formatDate(dateString) {
    const date = new Date(dateString);
    const day = date.getDate();
    const month = date.toLocaleString("default", { month: "short" });
    const year = date.getFullYear();
    return `${day} ${month} ${year}`;
  }

  function convertHeadingsToParagraphs(htmlContent) {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = htmlContent;
  
    const headings = tempDiv.querySelectorAll("h1, h2, h3, h4, h5, h6");
  
    headings.forEach((heading) => {
      const p = document.createElement("p");
  
      p.innerHTML = heading.innerHTML;
  
      p.style.fontWeight = "bold";
  
      p.style.margin = "0";
      p.style.padding = "0";
  
      heading.replaceWith(p);
    });
  
    return tempDiv.innerHTML;
  }
 console.log(getSingleQoutaion?.quotation,"data")
  return (
    <div id="quotation">
      <div className="d-flex justify-content-end px-5">
        <PDFDownloadLink
          document={<QuotationPDF quotation={getSingleQoutaion?.quotation} />}
          fileName="quotation.pdf"
        >
          {({ loading }) => (
            <button className="btn btn-danger">
              {loading ? "Generating PDF..." : "Download PDF"}
            </button>
          )}
        </PDFDownloadLink>
      </div>
      <div
        id="quotation-content"
        className="m-3 rounded quotation d-flex flex-column justify-content-between"
        style={{
          backgroundColor: "white",
          color: "black",
          padding: "16px",
          position: "relative",
          background: `white url(${BG}) center center no-repeat`,
          backgroundSize: "60%",
          fontSize: "12px",
        }}
      >
        <div className="d-flex justify-content-between mb-4">
          <div className="text-left">
            <img
              alt="Company Logo"
              src={AifaLogo}
              style={{ width: "60%", height: "auto" }}
            />
          </div>
          <div className="text-right">
            <h2 style={{ color: "black", marginTop: "10px" }}>Quotation</h2>
          </div>
        </div>
        <div
          className="row mb-4"
          style={{ fontWeight: "bold", color: "black" }}
        >
          <div className="col-4">
            <h5
              style={{ fontSize: "1.4rem", color: "black", fontWeight: "bold" }}
            >
              Quotation From
            </h5>
            <p style={{ fontWeight: "bold", color: "black", fontSize: "1rem" }}>
              AIFA Environmental Services & Pest Control LLC
            </p>
            <p
              style={{ fontWeight: "normal", color: "black", fontSize: "1rem" }}
            >
              Del Ani Holding Building, 1st Floor F03, Al Quoz Industrial Area
              3, Dubai, UAE
            </p>
            <p style={{ fontWeight: "bold", color: "black", fontSize: "1rem" }}>
              VAT Number:{" "}
              <span style={{ fontWeight: "normal", color: "black" }}>
                100242271300003
              </span>
            </p>
            <p style={{ fontWeight: "bold", color: "black", fontSize: "1rem" }}>
              Email:{" "}
              <span style={{ fontWeight: "normal", color: "black" }}>
                aifaservicesdxb@gmail.com
              </span>
            </p>
            <p style={{ fontWeight: "bold", color: "black", fontSize: "1rem" }}>
              Phone:{" "}
              <span style={{ fontWeight: "normal", color: "black" }}>
              +971-48347261
              </span>
            </p>
            <p style={{ fontWeight: "bold", color: "black", fontSize: "1rem" }}>
              Website:{" "}
              <span style={{ fontWeight: "normal", color: "black" }}>
                aifaservices.ae
              </span>
            </p>
          </div>

          <div className="col-4 text-left">
            <h5
              style={{ fontSize: "1.4rem", fontWeight: "bold", color: "black" }}
            >
              Subject :{getSingleQoutaion?.quotation?.quotaion}
            </h5>
            <h5
              style={{ fontSize: "1.4rem", fontWeight: "bold", color: "black" }}
            >
              Quotation For
            </h5>
            <p
              style={{ fontWeight: "normal", color: "black", fontSize: "1rem" }}
            >
              {getSingleQoutaion?.quotation?.customer?.firstname +
                " " +
                getSingleQoutaion?.quotation?.customer?.lastname}
            </p>
            <p
              style={{ fontWeight: "normal", color: "black", fontSize: "1rem" }}
            >
              {getSingleQoutaion?.quotation?.customer?.mailingAddress}
            </p>
            <p style={{ fontWeight: "bold", color: "black", fontSize: "1rem" }}>
              Phone:{" "}
              <span
                style={{
                  fontWeight: "normal",
                  color: "black",
                  fontSize: "1rem",
                }}
              >
                {getSingleQoutaion?.quotation?.customer?.phone}
              </span>
            </p>
            <p style={{ fontWeight: "bold", color: "black", fontSize: "1rem" }}>
              Email:{" "}
              <span
                style={{
                  fontWeight: "normal",
                  color: "black",
                  fontSize: "1rem",
                }}
              >
                {getSingleQoutaion?.quotation?.customer?.email}
              </span>
            </p>
            <p style={{ fontWeight: "bold", color: "black", fontSize: "1rem" }}>
              VAT Number:{" "}
              <span
                style={{
                  fontWeight: "normal",
                  color: "black",
                  fontSize: "1rem",
                }}
              >
                {getSingleQoutaion?.quotation?.customer?.TRN}
              </span>
            </p>
          </div>

          <div className="col-4 text-right" style={{ textAlign: "right" }}>
            <p style={{ fontWeight: "bold", color: "black", fontSize: "1rem" }}>
              Quotation No:{" "}
              <span
                style={{
                  fontWeight: "normal",
                  color: "black",
                  fontSize: "1rem",
                }}
              >
                {getSingleQoutaion?.quotation?.quotationNo}
              </span>
            </p>
            <p style={{ fontWeight: "bold", color: "black", fontSize: "1rem" }}>
              Quotation Date:{" "}
              <span
                style={{
                  fontWeight: "normal",
                  color: "black",
                  fontSize: "1rem",
                }}
              >
                {formatDate(getSingleQoutaion?.quotation?.startDate)}
              </span>
            </p>
            <p style={{ fontWeight: "bold", color: "black", fontSize: "1rem" }}>
              Valid Till:{" "}
              <span
                style={{
                  fontWeight: "normal",
                  color: "black",
                  fontSize: "1rem",
                }}
              >
                {formatDate(getSingleQoutaion?.quotation?.endDate)}
              </span>
            </p>
          </div>
        </div>

        <table className="table table-bordered" style={{overflowX:"auto"}}>
          <thead>
            <tr style={{ backgroundColor: "#d3e6f3" }}>
              <th style={{ color: "black", border: "black 1px solid" }}>
                Item
              </th>

              <th style={{ color: "black", border: "black 1px solid" }}>
                VAT Rate
              </th>
              <th style={{ color: "black", border: "black 1px solid" }}>
                Quantity
              </th>
              <th style={{ color: "black", border: "black 1px solid" }}>
                Rate
              </th>
              <th style={{ color: "black", border: "black 1px solid" }}>
                Discount
              </th>
              <th style={{ color: "black", border: "black 1px solid" }}>
                Amount
              </th>
              <th style={{ color: "black", border: "black 1px solid" }}>VAT</th>
              <th style={{ color: "black", border: "black 1px solid" }}>
                Total
              </th>
            </tr>
          </thead>
          <tbody>
            {getSingleQoutaion?.quotation?.subSeriviceList?.map(
              (data, index) => (
                <tr key={index} style={{ width: "100%" }}>
                  <td
                    style={{
                      color: "black",
                      border: "black 1px solid",
                      width: "20%",
                    }}
                  >
                    <span style={{ fontWeight: "bold" }}>
                      {" "}
                      {data?.subService?.name}
                    </span>
                    {data?.detail && (
                      <span style={{ display: "block" }}>
                        {" "}
                        {`(${data?.detail})`}
                      </span>
                    )}
                  </td>

                  <td style={{ color: "black", border: "black 1px solid" }}>
                    5%
                  </td>
                  <td style={{ color: "black", border: "black 1px solid" }}>
                    {data?.quantity}
                  </td>
                  <td style={{ color: "black", border: "black 1px solid" }}>
                    {parseFloat(data?.subTotal / data?.quantity)} AED
                  </td>
                  <td style={{ color: "black", border: "black 1px solid" }}>
                    {data?.discountAmount} AED
                  </td>
                  <td style={{ color: "black", border: "black 1px solid" }}>
                    {data?.priceAfterDiscount} AED
                  </td>
                  <td style={{ color: "black", border: "black 1px solid" }}>
                    {data?.vatAmount} AED
                  </td>
                  <td style={{ color: "black", border: "black 1px solid" }}>
                    {data?.netPrice} AED
                  </td>
                </tr>
              )
            )}
          </tbody>
        </table>

        <div className="row mt-4">
        <div className="col-md-6">
      <div className="p-3" style={{ backgroundColor: "#d9edf7" }}>
        <h5 style={{ color: "#009688", fontSize: "20px" }}>Bank Details</h5>
        <p className="mb-2" style={{ color: "black", marginBottom: "10px" }}>
          <strong>Account Name:</strong>
          <span style={{ color: "#000", marginLeft: "10px" }}>
            {bankDetails.AccountName}
          </span>
        </p>
        <p className="mb-2" style={{ color: "black", marginBottom: "10px" }}>
          <strong>Account Number:</strong>
          <span style={{ color: "#000", marginLeft: "10px" }}>
            {bankDetails.ACCOUNTNO}
          </span>
        </p>
        <p className="mb-2" style={{ color: "black", marginBottom: "10px" }}>
          <strong>IBAN:</strong>
          <span style={{ color: "#000", marginLeft: "10px" }}>
            {bankDetails.IBANNO}
          </span>
        </p>
        <p className="mb-2" style={{ color: "black", marginBottom: "10px" }}>
          <strong>SWIFT Code:</strong>
          <span style={{ color: "#000", marginLeft: "10px" }}>
            {bankDetails.SWIFTCODE}
          </span>
        </p>
        <p className="mb-2" style={{ color: "black", marginBottom: "10px" }}>
          <strong>Bank:</strong>
          <span style={{ color: "#000", marginLeft: "10px" }}>
            {bankDetails.BANKNAME}
          </span>
        </p>
        <p className="mb-2" style={{ color: "black", marginBottom: "10px" }}>
          <strong>Branch:</strong>
          <span style={{ color: "#000", marginLeft: "10px" }}>
            {bankDetails.BRANCHNAME}
          </span>
        </p>
        <p className="mb-2" style={{ color: "black", marginBottom: "10px" }}>
          <strong>Bank Address:</strong>
          <span style={{ color: "#000", marginLeft: "10px" }}>
            {bankDetails.BANKADDRESS}
          </span>
        </p>
        <p className="mb-2" style={{ color: "black", marginBottom: "10px" }}>
          <strong>Bank Tel No.:</strong>
          <span style={{ color: "#000", marginLeft: "10px" }}>
            {bankDetails.BANKTELNO}
          </span>
        </p>
      </div>
    </div>

          <div className="col-6">
            <table className="table table-bordered ">
              <tbody>
                <tr style={{ color: "black" }}>
                  <td style={{ fontSize: "1.1rem", border: "black 1px solid" }}>
                    Sub Total:
                  </td>
                  <td style={{ fontSize: "1.1rem", border: "black 1px solid" }}>
                    {getSingleQoutaion?.quotation?.pricesCalculation?.subtotal}{" "}
                    AED
                  </td>
                </tr>
                <tr style={{ color: "black" }}>
                  <td style={{ fontSize: "1.1rem", border: "black 1px solid" }}>
                    Discount:
                  </td>
                  <td style={{ fontSize: "1.1rem", border: "black 1px solid" }}>
                    {
                      getSingleQoutaion?.quotation?.pricesCalculation
                        ?.EstimatedDiscounts
                    }{" "}
                    AED
                  </td>
                </tr>
                <tr style={{ color: "black" }}>
                  <td style={{ fontSize: "1.1rem", border: "black 1px solid" }}>
                    Amount:
                  </td>
                  <td style={{ fontSize: "1.1rem", border: "black 1px solid" }}>
                    {
                      getSingleQoutaion?.quotation?.pricesCalculation
                        ?.beforeDiscountSubtotal
                    }{" "}
                    AED
                  </td>
                </tr>
                <tr style={{ color: "black" }}>
                  <td style={{ fontSize: "1.1rem", border: "black 1px solid" }}>
                    VAT:
                  </td>
                  <td style={{ fontSize: "1.1rem", border: "black 1px solid" }}>
                    {
                      getSingleQoutaion?.quotation?.pricesCalculation
                        ?.EstimatedTax
                    }{" "}
                    AED
                  </td>
                </tr>
                <tr style={{ backgroundColor: "#007aff", color: "white" }}>
                  <td style={{ fontSize: "1.1rem", border: "black 1px solid" }}>
                    <strong>Total (AED):</strong>
                  </td>
                  <td style={{ fontSize: "1.1rem", border: "black 1px solid" }}>
                    <strong>
                      {getSingleQoutaion?.quotation?.pricesCalculation?.total}{" "}
                      AED
                    </strong>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div className="row">
          <div className="col-6">
            <p
              dangerouslySetInnerHTML={{
                __html: convertHeadingsToParagraphs(
                  getSingleQoutaion?.quotation?.discription.replace(//g, "")
                ),
              }}
            ></p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuotationView;
